const fonts = {
  heading: 'Epilogue, sans-serif',
}

export default fonts
